import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  faAddressCard,
  faAngleRight,
  faArrowLeft,
  faBars,
  faBan,
  faCar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCalendarAlt,
  faCheck,
  faCoins,
  faCircleNotch,
  faClipboard,
  faCog,
  faCreditCard,
  faDollarSign,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileInvoiceDollar,
  faGasPump,
  faGrinStars,
  faInfoCircle,
  faKey,
  faLink,
  faLock,
  faMap,
  faPaperPlane,
  faPlusCircle,
  faQuestionCircle,
  faRoad,
  faSave,
  faSignInAlt,
  faSignOutAlt,
  faSpinner,
  faPhone,
  faTachometerAlt,
  faTimes,
  faUndo,
  faUser,
  faUsers,
  faSearch
} from '@fortawesome/free-solid-svg-icons';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    FontAwesomeModule
  ]
})
export class FontawesomeModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faAddressCard,
      faAngleRight,
      faArrowLeft,
      faBars,
      faBan,
      faCar,
      faCaretDown,
      faCaretLeft,
      faCaretRight,
      faCalendarAlt,
      faCheck,
      faCoins,
      faCircleNotch,
      faClipboard,
      faCog,
      faCreditCard,
      faDollarSign,
      faDownload,
      faEnvelope,
      faExclamationTriangle,
      faExternalLinkAlt,
      faEye,
      faEyeSlash,
      faFileInvoiceDollar,
      faGasPump,
      faGrinStars,
      faInfoCircle,
      faKey,
      faLink,
      faLock,
      faMap,
      faPaperPlane,
      faPlusCircle,
      faQuestionCircle,
      faRoad,
      faSave,
      faSignInAlt,
      faSignOutAlt,
      faSpinner,
      faPhone,
      faEnvelope,
      faTachometerAlt,
      faTimes,
      faUndo,
      faUser,
      faUsers,
      faUndo,
      faSearch
    );
  }
}
